// extracted by mini-css-extract-plugin
export var space = "Page-module--space--b30fd";